/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  ConfirmAssignData : null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.ConfirmAndAssignAction.CONFIRM_AND_ASSIGN:
      return {
        ...state,
    };
    case actions.ConfirmAndAssignAction.CONFIRM_AND_ASSIGN_RESPONSE:
          return{
      ...state,
      ConfirmAssignData : action.data,
    };
    case actions.ConfirmAndAssignAction.RESET_CONFIRM_AND_ASSIGN_RESPONSE:
      return{
        ...state,
        ConfirmAssignData : null
      }

    default:
      return state;
  }
};

export default reducer;
